import { Component, OnInit } from '@angular/core';
import { BookConfig } from '../../../../../models/book-config';
import { ApplicationStateService } from '../../../../../services/application-state.service';

@Component({
    selector: 'app-editions-dropdown',
    templateUrl: './editions-dropdown.component.html',
    styleUrls: ['./editions-dropdown.component.scss'],
    standalone: true
})
export class EditionsDropdownComponent implements OnInit {

    bookConfig: BookConfig;

    constructor(private applicationStateService: ApplicationStateService) {
    }

    ngOnInit(): void {
        this.bookConfig = this.applicationStateService.bookConfig;
    }

}
